/**
 * Actions Library - Central Export
 * Provides access to the centralized action registry, utilities, and action definitions
 */

// Registry
export { actionRegistry, initializeActionRegistry } from "./registry/ActionRegistry";
export {
  entityActionMap,
  registerEntityActions,
  getEntityActionsFn,
  getRegisteredEntities,
} from "./registry/EntityActionMap";

// Initialization
export { initializeAllEntityActions } from "./initialize";

// Main API
export { getEntityActions, getEntityActionsForContext, hasEntityActions } from "./getEntityActions";

// Hook
export { useEntityActions } from "./useEntityActions";
export type { UseEntityActionsOptions } from "./useEntityActions";

// Types - All consolidated in types/index.ts
export type {
  EntityKey,
  EntityRowType,
  EntityRowTypeMap,
  ActionHandlerName,
  ActionId,
  ActionContextType,
  DetailActionStrict,
  DetailActionTyped,
  IActionRegistry,
  EntityActionMapType,
  ActionsForEntity,
} from "./types";

export {
  ACTION_ROLES,
  ACTION_ICONS,
  ACTION_VARIANTS,
  ROLE_COMBINATIONS,
} from "./types";

// Action Definitions - Entity-specific actions
export {
  contactDetailActions,
  taskDetailActions,
  ticketDetailActions,
  companyDetailActions,
  dealDetailActions,
  timeEntryDetailActions,
} from "./definitions";

// Universal Actions
export {
  universalDeleteAction,
  universalEditAction,
  universalSendEmailAction,
  universalLogActivityAction,
  universalAskMeridianAction,
  universalMakeTicketAction,
  universalLogTimeEntryAction,
  universalViewCompanyAction,
  universalCreateTaskAction,
  universalScheduleMeetingAction,
  universalLinkCompanyAction,
  universalEnrichAction,
  universalViewDetailsAction,
} from "./definitions";

// Shared Action Builders
export {
  createStatusAction,
  createCallAction,
  createGenerateContractAction,
  createFillChecklistsAction,
  createManageAccessAction,
  createConsolidateAction,
  createResearchCompanyAction,
  createFindDecisionMakersAction,
  createDuplicateTaskAction,
  createQuickCompleteAction,
  createCompleteTaskAction,
  createAddUpdateAction,
  createAssignTicketAction,
  createCloseTicketAction,
  createAddCommentAction,
  createExportAction,
  createAdminOnlyAction,
  createEmployeeAndAdminAction,
  createAllAuthenticatedAction,
  createCustomRoleAction,
} from "./definitions";
